import { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from 'sonner';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ExpertisePillars } from './components/ExpertisePillars';
import { WorkSection } from './components/WorkSection';
import { PackagesSection } from './components/PackagesSection';
import { SocialProofSection } from './components/SocialProofSection';
import { InsightsSection } from './components/InsightsSection';
import { Footer } from './components/Footer';
import { QuestionnairePage } from './components/QuestionnairePage';
import { VoiceAgent } from './components/VoiceAgent';
import { LeadFormPage } from './components/LeadFormPage';
import { AdminPage } from './components/AdminPage';
import { GalleryPage } from './components/GalleryPage';
import { VisitorTracker } from './components/VisitorTracker';

function App() {
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => setCurrentPath(window.location.pathname);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Admin Dashboard page
  if (currentPath === '/admin') {
    return (
      <>
        <AdminPage />
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
            },
          }}
        />
      </>
    );
  }

  // Gallery page
  if (currentPath === '/gallery') {
    return (
      <>
        <VisitorTracker />
        <Navigation onOpenQuestionnaire={() => setShowQuestionnaire(true)} showQuestionnaire={false} />
        <GalleryPage />
        <Footer />
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
            },
          }}
        />
      </>
    );
  }

  // Lead Form standalone page
  if (currentPath === '/lead-form') {
    return (
      <>
        <VisitorTracker />
        <LeadFormPage />
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
            },
          }}
        />
      </>
    );
  }

  const handleOpenQuestionnaire = () => {
    setShowQuestionnaire(true);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const handleCloseQuestionnaire = () => {
    setShowQuestionnaire(false);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <div className="App">
      {/* Visitor Tracker - Analytics */}
      <VisitorTracker />
      
      {/* Noise Overlay */}
      <div className="noise-overlay" />
      
      {/* Navigation */}
      <Navigation 
        onOpenQuestionnaire={handleOpenQuestionnaire}
        showQuestionnaire={showQuestionnaire}
      />
      
      {/* Conditional Rendering - Questionnaire or Main Content */}
      {showQuestionnaire ? (
        <QuestionnairePage onBack={handleCloseQuestionnaire} />
      ) : (
        <main>
          {/* 1. Hero - Above the fold */}
          <HeroSection />
          
          {/* 2. About - Who is Kirit Sobti? */}
          <AboutSection />
          
          {/* 3. What I Work On - 4 Expertise Pillars */}
          <ExpertisePillars />
          
          {/* 4. Work - Track Record (merged Companies + Innovation + Climate) */}
          <WorkSection />
          
          {/* 5. Packages - Work With Kirit (PRIMARY CONVERSION) */}
          <PackagesSection />
          
          {/* 6. Social Proof - Testimonials + Media */}
          <SocialProofSection />
          
          {/* 7. Insights - Content Hub */}
          <InsightsSection />
          
          {/* 8. Contact - Final CTA & Footer */}
          <Footer />
        </main>
      )}
      
      {/* Toast Notifications */}
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
          },
        }}
      />
      
      {/* Voice Agent - Floating Button */}
      <VoiceAgent />
    </div>
  );
}

export default App;
